/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForAzureConsolidatedChargesReport extends models.ConfigurationForFinOpsConsolidatedReport {
    constructor() {
        super();
        this.setDiscriminator("ConfigurationForAzureConsolidatedChargesReport");
    }

    getFixupPrototypeFunction() { return ConfigurationForAzureConsolidatedChargesReport.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForAzureConsolidatedChargesReport>): ConfigurationForAzureConsolidatedChargesReport {
        let obj = Object.assign(new ConfigurationForAzureConsolidatedChargesReport(), model);
        ConfigurationForAzureConsolidatedChargesReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForAzureConsolidatedChargesReport>): ConfigurationForAzureConsolidatedChargesReport {
        if (!model) return null;
        return ConfigurationForAzureConsolidatedChargesReport.newInstance(<ConfigurationForAzureConsolidatedChargesReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForAzureConsolidatedChargesReport) {
        if (!obj) return;

        models.ConfigurationForAzureConsolidatedChargesReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForAzureConsolidatedChargesReport): boolean {
        if (models.ConfigurationForFinOpsConsolidatedReport.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForAzureConsolidatedChargesReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
